module.exports = __webpack_public_path__ + "media/images/flags/16/Estonia-0811d3fe53700579b6da262840e50ee2.png";